module.exports = __webpack_public_path__ + "img/heavy.3633529b.png";